import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const FinanceHubUnpaidInvoiceListItemFieldsFragmentDoc = gql`
  fragment FinanceHubUnpaidInvoiceListItemFields on UnpaidInvoiceListItem {
    amount_paid_in_micros
    currency_code
    customer_name
    days_overdue
    due_at
    erp_last_modified_at
    invoice_number
    is_partially_paid
    record_id
    record_type
    remaining_balance_in_micros
  }
`;
export const FinanceHubUnpaidInvoiceListDocument = gql`
  query FinanceHubUnpaidInvoiceList(
    $limit: Int!
    $offset: Int!
    $overdue_bucket: InvoiceListAgingBucket
    $record_type: InvoiceListRecordType
    $search_input: String
    $sort_by: InvoiceListSortField!
    $sort_direction: InvoiceListSortDirection!
  ) {
    getUnpaidInvoiceList(
      limit: $limit
      offset: $offset
      overdue_bucket: $overdue_bucket
      record_type: $record_type
      search_input: $search_input
      sort_by: $sort_by
      sort_direction: $sort_direction
    ) {
      has_more_pages
      invoices {
        ...FinanceHubUnpaidInvoiceListItemFields
      }
    }
  }
  ${FinanceHubUnpaidInvoiceListItemFieldsFragmentDoc}
`;
export function useFinanceHubUnpaidInvoiceListQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FinanceHubUnpaidInvoiceListQuery,
    Types.FinanceHubUnpaidInvoiceListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.FinanceHubUnpaidInvoiceListQuery,
    Types.FinanceHubUnpaidInvoiceListQueryVariables
  >(FinanceHubUnpaidInvoiceListDocument, options);
}
export function useFinanceHubUnpaidInvoiceListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FinanceHubUnpaidInvoiceListQuery,
    Types.FinanceHubUnpaidInvoiceListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.FinanceHubUnpaidInvoiceListQuery,
    Types.FinanceHubUnpaidInvoiceListQueryVariables
  >(FinanceHubUnpaidInvoiceListDocument, options);
}
export type FinanceHubUnpaidInvoiceListQueryHookResult = ReturnType<
  typeof useFinanceHubUnpaidInvoiceListQuery
>;
export type FinanceHubUnpaidInvoiceListLazyQueryHookResult = ReturnType<
  typeof useFinanceHubUnpaidInvoiceListLazyQuery
>;
export type FinanceHubUnpaidInvoiceListQueryResult = Apollo.QueryResult<
  Types.FinanceHubUnpaidInvoiceListQuery,
  Types.FinanceHubUnpaidInvoiceListQueryVariables
>;

/**
 * Wrapped version of useGeneratedFinanceHubUnpaidInvoiceListQuery using Pepper's useWrappedQuery
 */
export function useGeneratedFinanceHubUnpaidInvoiceListQuery(
  options?: Apollo.QueryHookOptions<
    Types.FinanceHubUnpaidInvoiceListQuery,
    Types.FinanceHubUnpaidInvoiceListQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.FinanceHubUnpaidInvoiceListQuery,
    Types.FinanceHubUnpaidInvoiceListQueryVariables
  >(FinanceHubUnpaidInvoiceListDocument, options);
}

/**
 * Wrapped version of useGeneratedFinanceHubUnpaidInvoiceListLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedFinanceHubUnpaidInvoiceListLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.FinanceHubUnpaidInvoiceListQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.FinanceHubUnpaidInvoiceListQuery,
    Types.FinanceHubUnpaidInvoiceListQueryVariables
  >(FinanceHubUnpaidInvoiceListDocument, lazyOptions);
}
